module.exports = __webpack_public_path__ + "static/media/email-logo-white.bd0cec86.svg";